import { TextField } from "@mui/material";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: "#fff",
  },
};

// A required, full-width text field in the look shared by the "פתיחת קריאה" form
const FormTextField = (props) => (
  <TextField required fullWidth variant="outlined" sx={fieldSx} {...props} />
);

export default FormTextField;
